import { StockItem as StockProps } from '@anm/api/modules/stocks';
import { StockName } from '@anm/api/modules/subscription';
import StockItemWrapper from '@anm/components/stocks/StockItem';
import { getPriceValue } from '@anm/components/stocks/StockList';
import useHover from '@anm/hooks/useHover';
import useSwitchState from '@anm/hooks/useSwitchState';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { stockSelectors } from '../../../../store/modules/stocks';
import StockModalView from '../../StockModalView';

type StockItemProps = {
  index: number;
  stock: StockProps;
  columnCount: number;
  columnWidth: number;
};

export const StockItem: FC<StockItemProps> = ({ stock, index, columnCount, columnWidth }) => {
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();
  const [isModalOpen, openModal, closeModal] = useSwitchState();

  const isVideo = stock.type === 'STOCK_VIDEO';
  const stockName = stock.service.toLowerCase().split('_')[0] as StockName;

  const stockPrice = useSelector(state =>
    stockSelectors.selectStockPrice(state, {
      isVideo,
      stockName
    })
  );
  const priceValue = getPriceValue(stockPrice);
  const columnProps = { index, columnCount, columnWidth };

  return (
    <>
      {isModalOpen && <StockModalView stockId={stock.id} {...{ priceValue }} onModalClose={closeModal} />}
      <StockItemWrapper
        onCardClick={openModal}
        {...{
          ...stock,
          isVideo,
          hoverRef,
          isHovered,
          priceValue,
          columnProps
        }}
      />
    </>
  );
};

export default StockItem;
